/**
 * Parses web traffic metrics from markdown content.
 *
 * Expected line format:
 *   👥 Total Sessions: Total 8188 (Daily Avg: 282) [Contact Click Sessions: 553 | Daily Avg: 19] | Ratio: 6.8%
 *
 * Returns { success, totalSessions, sources } or { success: false }.
 */

const METRIC_KEYS = [
  { match: /total sessions/i, key: 'total', label: 'Total Sessions', icon: '👥' },
  { match: /returning visitors/i, key: 'returning', label: 'Returning Visitors', icon: '🔁' },
  { match: /from organic/i, key: 'organic', label: 'From Organic', icon: '🔍' },
  { match: /from ads/i, key: 'ads', label: 'From Ads', icon: '📢' },
  { match: /from direct/i, key: 'direct', label: 'From Direct', icon: '➡️' },
  { match: /other\/unknown/i, key: 'other', label: 'Other/Unknown', icon: '🧩' },
]

const LINE_PATTERN =
  /Total\s+([\d,]+)\s*\(Daily Avg:\s*([\d,]+)\)\s*\[Contact Click Sessions:\s*([\d,]+)\s*\|\s*Daily Avg:\s*([\d,]+)\]\s*\|\s*Ratio:\s*([\d.]+)%/

function parseNum(s) {
  return parseInt(s.replace(/,/g, ''), 10) || 0
}

export function parseWebTraffic(raw) {
  if (!raw) return { success: false }

  const lines = raw.split('\n')
  const parsed = {}

  for (const line of lines) {
    for (const metric of METRIC_KEYS) {
      if (parsed[metric.key]) continue
      if (!metric.match.test(line)) continue
      const m = line.match(LINE_PATTERN)
      if (!m) continue
      parsed[metric.key] = {
        key: metric.key,
        icon: metric.icon,
        label: metric.label,
        total: parseNum(m[1]),
        dailyAvg: parseNum(m[2]),
        contactClicks: parseNum(m[3]),
        contactClicksDailyAvg: parseNum(m[4]),
        ratio: parseFloat(m[5]),
      }
      break
    }
  }

  // Must have at least Total Sessions to build the dashboard
  if (!parsed.total) return { success: false }

  const totalSessions = parsed.total

  const sources = METRIC_KEYS
    .filter(m => m.key !== 'total' && parsed[m.key])
    .map(m => parsed[m.key])

  return { success: true, totalSessions, sources }
}
